import { ExternalAspectData, newExternalAspectData } from "./asset-class-external-aspect.model";
import { AcGroundData, newAcGroundData } from "./asset-class-ground.model";
import { InternalAspectData, newInternalAspectData } from "./asset-class-internal-aspect.model";
import { ParcelIdentificationModel } from "./building.model";

export interface BuildingSectionData {
    building_id: number,
    building_name: string,
    completion_year: string,
    is_part_of_property: boolean,
    info_about_property: string,
    building_type: number,
    building_type_comment: string,
    building_grade_id: number,
    energy_efficiency_grade_id: number,
    developer: string,
    anchor_tenant: string,
    foundation_type_id: number,
    building_description: string

    estimated_age: number
    estimated_remaining_lifespan_from: number
    estimated_remaining_lifespan_to: number
    makani_no: string,
    municipality_number: string,
    height: string,
    dewa_no: string,
    plot_area: number
}
export class AssetClassBuilding {
    id: number;
    infoSection: BuildingSectionData;
    serviceAndInfra: {
        id: number,
        road: boolean;
        status_n_quality: string,
        access_points: string,
        length_of_road: string,
        ownership: string,

        central_heating: boolean,
        heatings: number[],
        other_heating: string,

        all_of_it: boolean,
        services: number[],
        other_service: string,

        ownership_of_common_areas_id: number,
        utilities_connection_status_id: number,
        electrical_option_id: number,
        electrical_condition_id: number
        water_option_id: number,
        water_condition_id: number
        drainage_option_id: number,
        drainage_condition_id: number
        elevators_option_id: number,
        elevators_condition_id: number
        air_conditioning_option_id: number,
        air_conditioning_condition_id: number
    }
    externalAspectData: ExternalAspectData;
    internalAspectData: InternalAspectData;
    grounds: AcGroundData;
    parcelIdentification: ParcelIdentificationModel;
    sizes: any[];
    constructionCategories: {id: number, title: string, description: string}[]
    accommodationLayoutFile: {
        name: string,
        path: string,
    }
    unitBreakdownFile: {
        name: string,
        path: string,
    }
    floorAreaMeasumentComment: string
    floorAreaMeasurements: {
        id: number,
        title: string,
        property_sub_type_id: number,
        measurement_standard_id: number,
        name: string,
        path: string
    }[]

    constructor() {
        this.id = null;
        this.infoSection = {
            building_id: null,
            building_name: null,
            completion_year: null,
            is_part_of_property: false,
            info_about_property: null,
            building_type: null,
            building_type_comment: null,
            building_grade_id: null,
            energy_efficiency_grade_id: null,
            developer: null,
            anchor_tenant: null,
            foundation_type_id: null,
            building_description: null,
            estimated_age: null,
            estimated_remaining_lifespan_from: null,
            estimated_remaining_lifespan_to: null,
            makani_no: null,
            municipality_number: null,
            height: null,
            dewa_no: null,
            plot_area: null
        }
        this.serviceAndInfra = {
            id: null,
            road: false,
            status_n_quality: null,
            access_points: null,
            length_of_road: null,
            ownership: null,

            central_heating: false,
            heatings: [],
            other_heating: null,

            all_of_it: false,
            services: [],
            other_service: null,

            ownership_of_common_areas_id: null,
            utilities_connection_status_id: null,
            electrical_condition_id: null,
            electrical_option_id: null,
            elevators_condition_id: null,
            elevators_option_id: null,
            water_condition_id: null,
            water_option_id: null,
            drainage_condition_id: null,
            drainage_option_id: null,
            air_conditioning_condition_id: null,
            air_conditioning_option_id: null
        }
        this.externalAspectData = newExternalAspectData();
        this.internalAspectData = newInternalAspectData();
        this.grounds = newAcGroundData();
        this.parcelIdentification = new ParcelIdentificationModel();
        this.sizes = [];
        this.constructionCategories = [],
        this.accommodationLayoutFile = null
        this.unitBreakdownFile = null
        this.floorAreaMeasumentComment = null
        this.floorAreaMeasurements = []
    }
}
